// src/pages/BalanceSheet/components/exportBalanceSheetCsv.js
// Zoho-style CSV export of the Balance Sheet (Assets, then Liabilities & Equity).
import { exportFinancialReportCsv } from "../../../../components/common/financialReportExport";
import { toBalanceSheetExportRows } from "./balanceSheetExportRows";

/**
 * @param {object} params
 * @param {Array}   params.liabilities - liabilities dataSource array from useBalanceSheetData
 * @param {Array}   params.assets      - assets dataSource array from useBalanceSheetData
 * @param {string}  params.title
 * @param {string}  params.basis       - e.g. "Accrual"
 * @param {string}  params.dateLabel   - e.g. "As of 30/09/2026"
 * @param {string}  params.filename
 */
export const exportBalanceSheetCsv = ({
  liabilities,
  assets,
  title = "Balance Sheet",
  basis = "Accrual",
  dateLabel = "",
  filename = "balance_sheet",
}) =>
  exportFinancialReportCsv({
    rows: toBalanceSheetExportRows({ assets, liabilities }),
    title,
    basis,
    dateLabel,
    filename,
  });
